import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label, Legend } from "recharts";
import { useIsMobile } from "@/hooks/use-mobile";

interface RevenueChartProps {
  chartData: Array<{
    name: string;
    Revenue: number;
    Profit: number;
  }>;
}

export const RevenueChart = ({ chartData }: RevenueChartProps) => {
  const isMobile = useIsMobile();
  
  const transformedData = [
    {
      name: 'Total',
      revenue: chartData[0].Revenue,
      profit: chartData[0].Profit
    }
  ];
  
  return (
    <div className="h-[300px] sm:h-[350px] bg-gradient-to-r from-background to-primary/5 rounded-lg p-2 sm:p-4">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart 
          data={transformedData}
          margin={{
            top: 20,
            right: isMobile ? 20 : 30,
            left: isMobile ? 0 : 10,
            bottom: isMobile ? 50 : 60,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" className="opacity-50" />
          <XAxis 
            dataKey="name" 
            tick={{ 
              fontSize: isMobile ? 10 : 12,
              fill: '#666',
              fontWeight: '500'
            }}
            interval={0}
          >
            <Label 
              value="Revenue & Profit Breakdown" 
              position="bottom" 
              offset={30}
              style={{
                fontSize: isMobile ? '12px' : '14px',
                fill: '#666',
                marginTop: '20px',
              }}
            />
          </XAxis>
          <YAxis 
            tick={{ fontSize: isMobile ? 10 : 12 }}
            width={isMobile ? 50 : 60}
          >
            <Label
              value="Amount (USD)"
              angle={-90}
              position="left"
              offset={isMobile ? -5 : 0}
              style={{
                fontSize: isMobile ? '12px' : '14px',
                fill: '#666',
                textAnchor: 'middle',
              }}
            />
          </YAxis>
          <Tooltip 
            formatter={(value) => {
              if (typeof value === 'number') {
                return `$${value.toFixed(2)}`;
              }
              return value;
            }}
            contentStyle={{
              fontSize: isMobile ? '12px' : '14px',
              padding: isMobile ? '8px' : '10px',
            }}
          />
          <Legend />
          <Bar 
            dataKey="revenue"
            name="Total Revenue"
            fill="#4ade80"
          />
          <Bar 
            dataKey="profit"
            name="Total Profit"
            fill="#3b82f6"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};